import {
  DotLoading,
  List,
  Modal,
  Popup,
  Tag,
  Toast,
  Tabs,
  Dialog,
} from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Card } from "react-bootstrap";
import { RightOutlined } from "@ant-design/icons"; // For right arrow icon
import PsContext from "../../context";
import { useNavigate } from "react-router-dom";
import { ServiceUrl } from "../../utils/serviceUrl";
import { FloatButton, Avatar, Space, Spin } from "antd";

import Header from "../header";
import InternalCircularView from "./internalCircularVIew";
import PsModalWindow from "../../utils/PsModalWindow";

const CircularList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [internalCircular, setInternalCircular] = useState([]);
  const [externalCircular, setExternalCircular] = useState([]);
  const [rolesAccess, setRolesAccess] = useState(false);
  const [activeTab, setActiveTab] = useState("internalcircular");
  const navigate = useNavigate();
  const [internalview, setInternalView] = useState(false);

  // State for managing pagination
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 50,
    },
    total: 0,
  });

  const styles = {
    circularCard: {
      padding: "20px",
      marginTop: "10px",
      borderRadius: "12px",
      backgroundColor: "#f9f9f9",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
      transition: "transform 0.2s",
    },
    cardTitle: {
      fontSize: "22px",
      color: "#333",
      fontWeight: "600",
    },
    cardSubtitle: {
      fontSize: "18px",
      color: "#555",
      marginBottom: "10px",
    },
    cardText: {
      fontSize: "15px",
      color: "#444",
      marginBottom: "15px",
    },
    cardAction: {
      display: "flex",
      justifyContent: "flex-end",
    },
    viewButton: {
      display: "flex",
      alignItems: "center",
      // backgroundColor: "rgb(235 108 2)",
      // color: "#fff",
      padding: "10px 15px",
      borderRadius: "5px",
      transition: "background-color 0.2s",
    },
  };

  useEffect(() => {
    setLoader(true); // Set loading state
    axios.post(ServiceUrl.MOB.LIST_INTENAL_CIRUCULAR).then((res) => {
      if (res["data"].status == "1") {
        setInternalCircular(res["data"].data); // Updated state
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  }, []);

  useEffect(() => {
    setLoader(true);
    axios.post(ServiceUrl.MOB.LIST_EXTERNAL_CIRUCULAR).then((res) => {
      if (res["data"].status == "1") {
        setExternalCircular(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  }, []);

  // Function to check if a circular is expired
  const isExpired = (expirationDate) => {
    const today = new Date();
    const expiration = new Date(expirationDate);
    return expiration < today; // Returns true if expired
  };

  const handleInternalView = (circular) => {
    navigate(`/staff/app/internal-college-circular/${circular.id}`);
  };

  const handleEnternalView = (circular) => {
    navigate(`/staff/app/external-college-circular/${circular.id}`);
  };

  return (
    <>
      <Header title="College Circular" backAction={true} rightActions={[]} />
      <div className="container leave">
        <Tabs
          className="bg-white"
          activeKey={activeTab}
          onChange={(k) => setActiveTab(k)}
        >
          <Tabs.Tab title={<>Internal Circular</>} key="internalcircular" />
          {rolesAccess && (
            <Tabs.Tab
              title="Staff Leaves waiting for your approval"
              key="staffleave"
            />
          )}
          <Tabs.Tab title={<>External Circular</>} key="externalcircular" />
        </Tabs>
      </div>

      <Spin spinning={loader}>
        {/* Render Internal Circulars */}
        {activeTab === "internalcircular" && (
          <div className="circular-list" style={styles.circularList}>
            <Row>
              {internalCircular.length > 0 ? (
                internalCircular
                  .filter((circular) => !isExpired(circular.expired_date))
                  .map((circular, index) => (
                    <Col key={index} sm={12} md={6} lg={4} className="mb-4">
                      <Card style={styles.circularCard}>
                        <Card.Body>
                          <Card.Title style={styles.cardTitle}>
                            <strong>{circular.title}</strong>
                          </Card.Title>
                          <Card.Subtitle style={styles.cardSubtitle}>
                            <strong>Department:</strong> {circular.department}
                          </Card.Subtitle>
                          <Card.Text style={styles.cardText}>
                            <strong>Expired Date:</strong>{" "}
                            <span style={{ color: "red" }}>
                              {circular.expired_date}
                            </span>
                          </Card.Text>
                          <div style={styles.cardAction}>
                            <Button
                              className="bg-theme"
                              style={styles.viewButton}
                              onClick={() => handleInternalView(circular)}
                            >
                              View Details <RightOutlined />
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
              ) : (
                <div className="text-center mt-4">
                  No Active Circulars Found
                </div>
              )}
            </Row>
          </div>
        )}

        {/* Render External Circulars */}
        {activeTab === "externalcircular" && (
          <div className="circular-list" style={styles.circularList}>
            <Row>
              {externalCircular.length > 0 ? (
                externalCircular
                  .filter((circular) => !isExpired(circular.expired_date))
                  .map((circular, index) => (
                    <Col key={index} sm={12} md={6} lg={4} className="mb-4">
                      <Card style={styles.circularCard}>
                        <Card.Body>
                          <Card.Title style={styles.cardTitle}>
                            <strong>{circular.circular_type}</strong>
                          </Card.Title>
                          <Card.Subtitle style={styles.cardSubtitle}>
                            <strong>Department:</strong> {circular.department}
                          </Card.Subtitle>
                          <Card.Text style={styles.cardText}>
                            <strong>Circular Number :</strong>{" "}
                            <span style={{ color: "red" }}>
                              {circular.circular_number}
                            </span>
                          </Card.Text>
                          <div style={styles.cardAction}>
                            <Button
                              className="bg-theme"
                              style={styles.viewButton}
                              onClick={() => handleEnternalView(circular)}
                            >
                              View Details <RightOutlined />
                            </Button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
              ) : (
                <div className="text-center mt-4">
                  No Active Circulars Found
                </div>
              )}
            </Row>
          </div>
        )}

        {/* Render Staff Leaves */}
        {rolesAccess && activeTab === "staffleave" && (
          <div className="text-center mt-4">Staff Leaves Section</div>
        )}
      </Spin>

      <PsModalWindow
        title="View Internal Circular"
        onHide={() => setInternalView(false)}
        show={internalview}
        size="lg"
      >
        <InternalCircularView
          dataSource={internalCircular.id}
          onSuccess={() => {
            setInternalView(false);
          }}
        />
      </PsModalWindow>
    </>
  );
};

export default CircularList;
